<template>
  <div v-if="isSiteLoadDone && site">
    <div
      v-if="site.isMenuHorizontalStyle && staticMenuItemList.length !== 0"
      class="horizontal-menu-grey-zone d-flex flex-wrap justify-content-end align-items-center"
    >
      <li
        v-for="menuItem in staticMenuItemList"
        :key="menuItem.id + '_staticMenuItem'"
        class="nav-item d-flex align-items-center h-100 cursor-pointer"
      >
        <a
          v-if="menuItem.isOuterLink"
          :href="menuItem.link"
          target="_blank"
          class="h-100 w-100 d-flex align-items-center justify-content-between"
        >
          {{ menuItem.name }}
        </a>
        <router-link
          v-else
          :to="menuItem.link"
          class="h-100 w-100 d-flex align-items-center justify-content-between"
        >
          {{ menuItem.name }}
        </router-link>
      </li>
    </div>
    <header class="header">
      <div class="d-flex h-100">
        <div
          v-if="!isMobileSearchOpen"
          class="col-6 d-flex justify-content-start pl-3 pl-lg-5"
          :class="site.isMenuHorizontalStyle ? 'col-md-2' : 'col-md-3'"
        >
          <div
            v-if="isMobile || !site.isMenuHorizontalStyle"
            class="h-100 d-flex align-items-center"
            @click="toggleMegaMenu"
          >
            <div
              class="mega-menu-icon cursor-pointer"
              :class="{
                'open': isMegaMenuOpen,
                'badge-after upper-corner': isMobile && unreadMessagesCount > 0,
              }"
            >
              <span />
              <span />
              <span />
              <span />
            </div>
          </div>
          <router-link
            v-if="site.logoSrc"
            class="d-flex align-items-center w-100"
            :class="{
              'ml-4': isMobile || !site.isMenuHorizontalStyle,
            }"
            to="/"
            aria-label="Home"
          >
            <div
              class="d-flex logo w-100"
              :style="{'background-image': 'url(' + site.logoSrc + ')'}"
            />
          </router-link>
        </div>
        <div v-if="isMobile && isMobileSearchOpen" class="col-12 col-md-6 d-flex justify-content-center">
          <header-search
            :class="{
              'w-75': !isMobile,
              'w-100 col-12': isMobile,
            }"
            @closeSearch="closeSearch"
          />
        </div>
        <div
          v-else-if="!isMobile"
          class="col-12 d-flex justify-content-center"
          :class="site.isMenuHorizontalStyle ? 'col-md-8' : 'col-md-6'"
        >
          <div
            class="position-relative d-flex align-items-center justify-content-center"
            :class="{
              'header-search-visible': isHorizontalStyleMenuSearchOpen,
              'header-search-container': site.isMenuHorizontalStyle,
              'w-100': !site.isMenuHorizontalStyle,
            }"
          >
            <header-search
              :class="{
                'w-75': !isMobile,
                'w-100 col-12': isMobile,
              }"
              @closeSearch="closeSearch"
            />
          </div>
          <div
            v-if="site.isMenuHorizontalStyle"
            class="position-absolute h-100 w-100"
            :class="{
              'with-grey-bar': staticMenuItemList.length !== 0,
            }"
          >
            <mega-menu
              :is-mega-menu-open="true"
            />
          </div>
        </div>
        <div
          v-if="!isMobileSearchOpen"
          class="col-6 d-flex justify-content-end align-items-center pr-4 pr-lg-5"
          :class="{
            'header-action-container col-md-2': site.isMenuHorizontalStyle,
            'header-action-container col-md-3': !site.isMenuHorizontalStyle,
          }"
        >
          <div
            v-if="!isMobile && site.isMenuHorizontalStyle"
            class="mr-3 cursor-pointer"
            :class="isHorizontalStyleMenuSearchOpen ? 'close-icon' : 'header-search-icon'"
            @click="isHorizontalStyleMenuSearchOpen = !isHorizontalStyleMenuSearchOpen"
          />
          <router-link
            v-if="!isLoggedIn"
            to="/login"
            class="header-icon user mr-4 d-none d-md-block"
            :class="{
              'ml-2': site.isMenuHorizontalStyle,
            }"
            :aria-label="$t('belepes_vagy_regisztracio')"
          />
          <b-dropdown
            v-else
            class="header-profile-dropdown mr-2 d-none d-md-block"
          >
            <template #button-content>
              <div
                class="w-100 h-100"
                :class="{
                  'badge-after': unreadMessagesCount > 0,
                }"
              >
                <img
                  class="avatar mr-2"
                  :src="user.avatarSrc"
                  :alt="$t('profilom')"
                >
              </div>
            </template>
            <template v-if="site.isMenuHorizontalStyle">
              <b-dropdown-item disabled>
                <div class="py-2 d-flex">
                  <div class="mr-4 position-relative">
                    <img class="avatar large-size" :src="user.avatarLargeSrc">
                  </div>
                  <div class="ml-4 text-center">
                    <div class="font-weight-bold" v-text="user.username" />
                    <div v-text="user.userPoint + ' ' + $t('term_pont')" />
                  </div>
                </div>
              </b-dropdown-item>
              <b-dropdown-item @click="goToProfileTab">
                <router-link
                  :to="{ name: pageNames.PAGE_PROFILE_MY_PROFILE, query: { tab: 'personal', subTab: 'personal' } }"
                  class="dropdown-navigation-link"
                  :aria-label="$t('profilom')"
                >
                  <div class="py-2 d-flex justify-content-between w-100">
                    <div class="d-flex align-items-center">
                      <div class="dropdown-icon mr-2 personal-details" />
                      <div
                        v-t="'profilom'"
                        data-cy="profile-btn"
                      />
                    </div>
                    <div
                      v-if="unreadMessagesCount > 0"
                      class="badge-large"
                      v-text="unreadMessagesCount"
                    />
                  </div>
                </router-link>
              </b-dropdown-item>
              <b-dropdown-item>
                <router-link
                  :to="{ name: pageNames.PAGE_PROFILE_MY_PROFILE, query: { tab: 'order' } }"
                  class="dropdown-navigation-link"
                  :aria-label="$t('rendeleseim')"
                >
                  <div class="py-2 d-flex align-items-center w-100">
                    <div class="dropdown-icon mr-2 orders" />
                    <div
                      v-t="'rendeleseim'"
                    />
                  </div>
                </router-link>
              </b-dropdown-item>

              <b-dropdown-item>
                <router-link
                  :to="{ name: pageNames.PAGE_PROFILE_MY_PROFILE, query: { tab: 'favorite' } }"
                  class="dropdown-navigation-link"
                  :aria-label="$t('menu_shop_kedvencek')"
                >
                  <div class="py-2 d-flex align-items-center w-100">
                    <div class="dropdown-icon mr-2 favorites" />
                    <div
                      v-t="'menu_shop_kedvencek'"
                    />
                  </div>
                </router-link>
              </b-dropdown-item>
              <b-dropdown-item>
                <router-link
                  :to="{ name: pageNames.PAGE_PROFILE_MY_PROFILE, query: { tab: 'messages' } }"
                  class="dropdown-navigation-link"
                  :aria-label="$t('uzeneteim')"
                >
                  <div class="py-2 d-flex align-items-center w-100">
                    <div class="dropdown-icon mr-2 messages" />
                    <div
                      v-t="'uzeneteim'"
                    />
                  </div>
                </router-link>
              </b-dropdown-item>
              <b-dropdown-item>
                <router-link
                  :to="{ name: pageNames.PAGE_PROFILE_MY_PROFILE, query: { tab: 'questions' } }"
                  class="dropdown-navigation-link"
                  :aria-label="$t('termekkerdeseim')"
                >
                  <div class="py-2 d-flex align-items-center w-100">
                    <div class="dropdown-icon mr-2 questions" />
                    <div
                      v-t="'termekkerdeseim'"
                    />
                  </div>
                </router-link>
              </b-dropdown-item>
              <b-dropdown-item @click="goToDiscountTab">
                <router-link
                  :to="{ name: pageNames.PAGE_PROFILE_MY_PROFILE, query: { tab: 'personal', subTab: 'discount' } }"
                  class="dropdown-navigation-link"
                  :aria-label="$t('husegpontok')"
                >
                  <div class="py-2 d-flex align-items-center w-100">
                    <div class="dropdown-icon mr-2 points" />
                    <div
                      v-t="'husegpontok'"
                    />
                  </div>
                </router-link>
              </b-dropdown-item>
              <b-dropdown-item @click="userLogout">
                <a
                  class="dropdown-navigation-link d-flex align-items-center"
                  data-cy="logout-btn"
                >
                  <div class="dropdown-icon mr-2 logout" />
                  <div v-t="'kilepes'" class="py-2" />
                </a>
              </b-dropdown-item>
            </template>
            <template v-else>
              <b-dropdown-item>
                <router-link
                  :to="{ name: 'myprofile', query: { tab: 'personal' } }"
                  class="dropdown-navigation-link"
                  :aria-label="$t('profilom')"
                >
                  <div class="py-2 d-flex justify-content-between w-100">
                    <div
                      v-t="'profilom'"
                      data-cy="profile-btn"
                    />
                    <div
                      v-if="unreadMessagesCount > 0"
                      class="badge-large"
                      v-text="unreadMessagesCount"
                    />
                  </div>
                </router-link>
              </b-dropdown-item>
              <b-dropdown-item @click="userLogout">
                <a
                  class="dropdown-navigation-link"
                  data-cy="logout-btn"
                >
                  <div v-t="'kilepes'" class="py-2" />
                </a>
              </b-dropdown-item>
            </template>
          </b-dropdown>
          <div
            v-if="isMobile"
            class="header-icon search cursor-pointer mr-4"
            @click="openMobileSearch"
          />
          <div
            v-if="site && site.isShopSite"
            v-b-toggle.cart-collapse
            class="header-icon cart cursor-pointer"
          >
            <div
              class="cart-badge"
              v-text="cartItemCount"
            />
          </div>
        </div>
      </div>
    </header>
    <breadcrumb />
    <cart
      v-if="site.isShopSite && !isOnCheckoutPage"
      @isCartVisible="sendCartViewEvent($event)"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { BDropdown, BDropdownItem, VBToggle } from 'bootstrap-vue'
import Breadcrumb from '../breadcrumb/breadcrumb.vue'
import pageNames from '../../constant/pageNames.js'
import Vue from 'vue'
import Axios from 'axios'

Vue.directive('b-toggle', VBToggle)

export default {
  name: 'HeaderComponent',
  components: {
    Breadcrumb, // ezt nem tudjuk lazy load-olni, mert akkor initkor még nem lenne breadcrumb
    'header-search': () => import(/* webpackChunkName: "headerSearch" */ '../header-search/header-search.vue'),
    'cart': () => import(/* webpackChunkName: "cart" */ '../cart/cart.vue'),
    'mega-menu': () => import(/* webpackChunkName: "MegaMenu" */ '../MegaMenu/MegaMenu.vue'),
    'b-dropdown': BDropdown,
    'b-dropdown-item': BDropdownItem,
  },
  props: {
    /**
     * épp 404 vue page-t mutatjuk-e
     */
    isShowingNotFoundPage: {
      type: Boolean,
      default: false,
    },
    /**
     * nyitva van-e a menu
     */
    isMegaMenuOpen: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      /**
       * mobilon látszik-e a kereső
       */
      isSearchOpenOnMobile: false,
      /**
       * mobile kereső nyitva van-e
       */
      isMobileHeaderSearchOpen: false,
      /**
       * router által használt oldalak nevei
       */
      pageNames: pageNames,
      /**
       * horizontal style menu kereső nyitva van-e
       *
       * @type {Boolean}
       */
      isHorizontalStyleMenuSearchOpen: false,
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'User/isLoggedIn',
      site: 'Site/getSite',
      menuItems: 'Site/getMenuItems',
      isSiteLoadDone: 'Site/isSiteLoadDone',
      favorites: 'User/getFavorites',
      favoritesCount: 'User/getFavoritesCount',
      user: 'User/getUser',
      unreadMessagesCount: 'User/getUnreadMessagesCount',
      basicCheckoutData: 'Cart/getBasicCheckoutData',
      isBasicCheckoutDataLoaded: 'Cart/getIsBasicCheckoutDataLoaded',
      getCartEditData: 'Cart/getCartEditData',
      getIsCartEditDataLoaded: 'Cart/getIsCartEditDataLoaded',
      isCartHeaderExists: 'Cart/getIsCartHeaderExists',
      menu: 'MegaMenu/getMenu',
      isMenuLoadDone: 'MegaMenu/isMenuLoadDone',
      isMenuLoading: 'MegaMenu/isMenuLoading',
    }),
    /**
     * kosár elemek száma
     */
    cartItemCount() {
      if (!this.isCartHeaderExists) {
        return 0
      }
      return this.basicCheckoutData.cartItemCount
    },
    isMobileSearchOpen() {
      return (this.isMobile && this.isMobileHeaderSearchOpen)
    },
    /**
     * static (szürke zónás) itemeklistája
     */
    staticMenuItemList() {
      if (!this.site.isMenuHorizontalStyle || this.isMobile) {
        return []
      }
      if (!this.isMenuLoadDone && !this.isMenuLoading) {
        this.loadMenu()
      }
      return this.menu.filter(menuItem => menuItem.isStaticItem)
    },
    /**
     * mobil nézet-e
     *
     * @return {boolean}
     */
    isMobile() {
      return this.$mq === 'sm' || this.$mq === 'md'
    },
    /**
     * checkout oldalon vagyunk-e?
     */
    isOnCheckoutPage() {
      return this.$route.name === 'checkout'
    },
  },
  methods: {
    ...mapActions({
      loadMenu: 'MegaMenu/loadMenu',
    }),
    openMobileSearch() {
      this.closeMegaMenu()
      this.isMobileHeaderSearchOpen = true
      window.disableScroll()
    },
    closeSearch() {
      this.isMobileHeaderSearchOpen = false
      this.isHorizontalStyleMenuSearchOpen = false
      window.enableScroll()
    },
    /**
     * nyitott almenü bezárása
     */
    closeSubMenu() {
      if (!this.isSiteLoadDone || !this.menuItems || !this.menuItems.forEach) {
        return
      }
      this.menuItems.forEach((menuItem, index) => {
        if (
          (menuItem.manufacturers || menuItem.sub) &&
          this.$refs['submenu-collapse-' + index][0] !== undefined &&
          this.$refs['submenu-collapse-' + index][0].classList.contains('not-collapsed',
          )) {
          this.$root.$emit('bv::toggle::collapse', 'submenu-collapse-' + index)
        }
      })
    },
    /**
     * profil discount tabra váltás
     */
    goToDiscountTab() {
      if (this.$route.name === pageNames.PAGE_PROFILE_MY_PROFILE && this.$route.query.tab === 'personal' && this.$route.query.subTab !== 'discount') {
        this.$router.replace({
          query: {
            tab: 'personal',
            subTab: 'discount',
          },
        })
      }
    },
    /**
     * profil alap tabra váltás
     */
    goToProfileTab() {
      if (this.$route.name === pageNames.PAGE_PROFILE_MY_PROFILE && this.$route.query.tab === 'personal' && this.$route.query.subTab !== 'personal') {
        this.$router.replace({
          query: {
            tab: 'personal',
            subTab: 'personal',
          },
        })
      }
    },
    /**
     * user logout
     */
    userLogout() {
      this.$store.dispatch('User/logout')
        .then(() => {
          this.$store.dispatch('User/afterLoginOrLogout')
            .then(() => {
              this.$store.dispatch('Cart/resetDataLoadedFlags')
              this.$store.dispatch('Cart/getBasicCheckoutData', true)
              this.$store.dispatch('Cart/getCartEditData', true)
              this.$store.dispatch('Cart/getCartAddressData', true)
              if (this.$route.name !== 'home') {
                this.$router.push({ name: 'home' })
              }
            })
        })
    },
    /**
     * megamenü nyitása/zárása
     */
    toggleMegaMenu() {
      this.$emit('toggleMegaMenu')
    },
    /**
     * megamenü bezárása
     */
    closeMegaMenu() {
      this.$emit('closeMegaMenu')
    },
    /**
     * social event GA küldése
     *
     * @param key
     */
    sendSocialGaEvent(key) {
      ga('send', 'event', 'Click', 'Kikattintás', key)
    },
    /**
     * ha lenyitjuk a kosarat (jobb felső kosár ikonra katintva)
     *
     * @param isCartVisible
     */
    sendCartViewEvent(isCartVisible) {
      if (!isCartVisible) {
        return
      }
      Axios.post('/Shop/api/cartOpen')
    },
  },
}
</script>

<style lang="scss" scoped src="./header-component.scss" />
